export const P_BOX_NOT_ACCEPTED_LABEL: string = "PO Boxes not accepted.";
export const STREET_API_SYSTEM_DOWN_LABEL: string = "Address verification system is offline. Please try again later.";
export const ADDRESS_INPUT_LABEL: string = "Street Address";
export const UNKNOWN_LABEL: string = "Unknown";
